import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccordionBlok, LazyCenteredAccordion, LazyBlogSectionWithBackgroundImages, LazyBodyStyleBar, LazyCallToAction, LazyCallToActionSimpleCentered, LazyCallToActionSimpleJustified, LazyCallToActionSplitPanel, LazyCallToActionBackgroundImage, LazyCallToActionImage, LazyCallToActionOverlap, Lazy3ColumnCollection, LazyContentWithImageTiles, LazySearchBar, LazyFeature2, LazyFeatureSectionWithLargeVideo, LazyFlexPortraitVideo, LazyFlexVideo, LazyFullWidthBlok, LazyGrid, LazyGridImage, LazyGridRichText, LazyGridx4, LazyHeading, LazyRichText, LazySpacer, LazySimpleHeader, LazyIncentives3ColumnPanel, LazyIncentives3ColumnWithHeader, LazyInventoryBar, LazyInventoryGrid, LazyLargeVideo, LazyBrandCarousel, LazyLogoCarousel, LazyLogoCloud, LazyLogoCloudItem, LazyProductFeaturesSplit, LazyProductFeaturesWithAlternatingSections, LazyProductFeaturesWithSquareImages, LazyPromoSectionFullWidthWithBackgroundImage, LazyPromoSectionFullWidthWithOverlappingImageTiles, LazyPromoSectionLargeWithBackgroundImage, LazyPromoSectionWithBackgroundImage, LazyPromoSectionWithFadingBackgroundImage, LazyPromoSectionWithOverlappingImageTiles, LazyRecentlyViewed, LazySimpleStats, LazyTeamSectionWithVerticalImages, LazyTestimonialSideBySide, LazyTestimonialWithBackgroundImage, LazyTestimonialWithLargeAvatar, LazyTestimonialWithOverlappingImage, LazyVehicleShipping, LazyYoutubeVideo, LazyVideo1, LazyFullWidthHero, LazyFullWidthPromotionSliderHero, LazyFullwidthhero1, LazyHero1, LazyHero2, LazySplitPaneHero, LazyTabColumns, LazyTabImageGrid, LazyTabLink, LazyTabSimple, LazyPage, LazyKbbAppraisal, LazySellHeader, LazyStoryblokCatchAll, LazyCapitalOneCalculator, LazyCapitalOneLeadsNavigator, LazyCapitalOnePrequalification, LazyCapitalOneShowroom, LazyEdmundsTradeIn, LazyEdmundsTradeInWidget, LazyEdmundsTradeInWidgetSlim, LazyIpacketButton, LazySvgoAtvs, LazySvgoAutomotiveJaguar, LazySvgoAutomotiveJeep, LazySvgoAutomotiveMini, LazySvgoAutomotiveMitsubishi, LazySvgoAutomotiveMustang, LazySvgoAutomotiveNissan, LazySvgoAutomotiveOpel, LazySvgoAutomotivePagani, LazySvgoAutomotivePanoz, LazySvgoAutomotivePeterbilt, LazySvgoAutomotivePeugeot, LazySvgoAutomotivePlymouth, LazySvgoAutomotivePolestar, LazySvgoAutomotivePontiac, LazySvgoAutomotivePorsche, LazySvgoAutomotiveProton, LazySvgoAutomotiveAbarth, LazySvgoAutomotiveAcura, LazySvgoAutomotiveAixam, LazySvgoAutomotiveAlfaRomeo, LazySvgoAutomotiveAlpinaBovensiepen, LazySvgoAutomotiveAmg, LazySvgoAutomotiveAstonMartin, LazySvgoAutomotiveAudi, LazySvgoAutomotiveBentley, LazySvgoAutomotiveBmw, LazySvgoAutomotiveBrabus, LazySvgoAutomotiveBrilliance, LazySvgoAutomotiveBugatti, LazySvgoAutomotiveBuick, LazySvgoAutomotiveBydAuto, LazySvgoAutomotiveCadillac, LazySvgoAutomotiveCat, LazySvgoAutomotiveChana, LazySvgoAutomotiveChery, LazySvgoAutomotiveChevrolet, LazySvgoAutomotiveChrysler, LazySvgoAutomotiveCitroen, LazySvgoAutomotiveCorvette, LazySvgoAutomotiveCupra, LazySvgoAutomotiveDacia, LazySvgoAutomotiveDaewoo, LazySvgoAutomotiveDaf, LazySvgoAutomotiveDaihatsu, LazySvgoAutomotiveDaimler, LazySvgoAutomotiveDmc, LazySvgoAutomotiveDodge, LazySvgoAutomotiveDs, LazySvgoAutomotiveFerrari, LazySvgoAutomotiveFiat, LazySvgoAutomotiveFisker, LazySvgoAutomotiveFord, LazySvgoAutomotiveFreightlinerTrucks, LazySvgoAutomotiveGaz, LazySvgoAutomotiveGeely, LazySvgoAutomotiveGinetta, LazySvgoAutomotiveGmc, LazySvgoAutomotiveHolden, LazySvgoAutomotiveHonda, LazySvgoAutomotiveHummer, LazySvgoAutomotiveHyundai, LazySvgoAutomotiveInfiniti, LazySvgoAutomotiveInternational, LazySvgoAutomotiveIsuzu, LazySvgoAutomotiveIveco, LazySvgoAutomotiveKenworth, LazySvgoAutomotiveKia, LazySvgoAutomotiveKoenigsegg, LazySvgoAutomotiveKomatsu, LazySvgoAutomotiveLada, LazySvgoAutomotiveLamborghini, LazySvgoAutomotiveLancia, LazySvgoAutomotiveLandRover, LazySvgoAutomotiveLexus, LazySvgoAutomotiveLincoln, LazySvgoAutomotiveLotus, LazySvgoAutomotiveLucid, LazySvgoAutomotiveMackTrucks, LazySvgoAutomotiveMagirus, LazySvgoAutomotiveMan, LazySvgoAutomotiveMaserati, LazySvgoAutomotiveMaybach, LazySvgoAutomotiveMazda, LazySvgoAutomotiveMclaren, LazySvgoAutomotiveMercedes, LazySvgoAutomotiveMercury, LazySvgoAutomotiveMg, LazySvgoAutomotivePontiacTransAm, LazySvgoAutomotiveRamTrucks, LazySvgoAutomotiveRangeRover, LazySvgoAutomotiveRenaultTrucks, LazySvgoAutomotiveRenault, LazySvgoAutomotiveRimac, LazySvgoAutomotiveRollsRoyce, LazySvgoAutomotiveRover, LazySvgoAutomotiveSaabScania, LazySvgoAutomotiveSaab, LazySvgoAutomotiveSeat, LazySvgoAutomotiveShelbyCobra, LazySvgoAutomotiveShelby, LazySvgoAutomotiveSkoda, LazySvgoAutomotiveSmart, LazySvgoAutomotiveSsangyong, LazySvgoAutomotiveSubaru, LazySvgoAutomotiveSuzuki, LazySvgoAutomotiveTata, LazySvgoAutomotiveTesla, LazySvgoAutomotiveToyota, LazySvgoAutomotiveUaz, LazySvgoAutomotiveUdTrucks, LazySvgoAutomotiveVolkswagen, LazySvgoAutomotiveVolvo, LazySvgoAutomotiveWesternStar, LazySvgoCars, LazySvgoCertifiedPreOwned, LazySvgoFacebook, LazySvgoFeaturesAdaptiveCruiseControl, LazySvgoFeaturesAndroidAuto, LazySvgoFeaturesAppleCarplay, LazySvgoFeaturesAutomaticClimateControl, LazySvgoFeaturesAutomaticCruiseControl, LazySvgoFeaturesBackupCamera, LazySvgoFeaturesBlindSpotMonitor, LazySvgoFeaturesBluetooth, LazySvgoFeaturesCollisionWarning, LazySvgoFeaturesFogLights, LazySvgoFeaturesHeatedSeats, LazySvgoFeaturesKeylessEntry, LazySvgoFeaturesLaneDepartureWarning, LazySvgoFeaturesLaneKeepAssist, LazySvgoFeaturesLeatherSeats, LazySvgoFeaturesNavigation, LazySvgoFeaturesPanoramicSunroof, LazySvgoFeaturesParkingSenorsAssist, LazySvgoFeaturesPowerSeats, LazySvgoFeaturesPremiumAudio, LazySvgoFeaturesPushStart, LazySvgoFeaturesRainSensingWipers, LazySvgoFeaturesRearAc, LazySvgoFeaturesRemoteStart, LazySvgoFeaturesSatelliteRadioReady, LazySvgoFeaturesSunroof, LazySvgoFeaturesTowPackage, LazySvgoFeaturesWiFiHotspot, LazySvgoFeaturesWirelessPhoneCharging, LazySvgoFeaturesXenonHeadlights, LazySvgoInstagram, LazySvgoLeaf, LazySvgoPlug, LazySvgoX, LazySvgoYoutube } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccordionBlok", LazyAccordionBlok],
["CenteredAccordion", LazyCenteredAccordion],
["BlogSectionWithBackgroundImages", LazyBlogSectionWithBackgroundImages],
["BodyStyleBar", LazyBodyStyleBar],
["CallToAction", LazyCallToAction],
["CallToActionSimpleCentered", LazyCallToActionSimpleCentered],
["CallToActionSimpleJustified", LazyCallToActionSimpleJustified],
["CallToActionSplitPanel", LazyCallToActionSplitPanel],
["CallToActionBackgroundImage", LazyCallToActionBackgroundImage],
["CallToActionImage", LazyCallToActionImage],
["CallToActionOverlap", LazyCallToActionOverlap],
["3ColumnCollection", Lazy3ColumnCollection],
["ContentWithImageTiles", LazyContentWithImageTiles],
["SearchBar", LazySearchBar],
["Feature2", LazyFeature2],
["FeatureSectionWithLargeVideo", LazyFeatureSectionWithLargeVideo],
["FlexPortraitVideo", LazyFlexPortraitVideo],
["FlexVideo", LazyFlexVideo],
["FullWidthBlok", LazyFullWidthBlok],
["Grid", LazyGrid],
["GridImage", LazyGridImage],
["GridRichText", LazyGridRichText],
["Gridx4", LazyGridx4],
["Heading", LazyHeading],
["RichText", LazyRichText],
["Spacer", LazySpacer],
["SimpleHeader", LazySimpleHeader],
["Incentives3ColumnPanel", LazyIncentives3ColumnPanel],
["Incentives3ColumnWithHeader", LazyIncentives3ColumnWithHeader],
["InventoryBar", LazyInventoryBar],
["InventoryGrid", LazyInventoryGrid],
["LargeVideo", LazyLargeVideo],
["BrandCarousel", LazyBrandCarousel],
["LogoCarousel", LazyLogoCarousel],
["LogoCloud", LazyLogoCloud],
["LogoCloudItem", LazyLogoCloudItem],
["ProductFeaturesSplit", LazyProductFeaturesSplit],
["ProductFeaturesWithAlternatingSections", LazyProductFeaturesWithAlternatingSections],
["ProductFeaturesWithSquareImages", LazyProductFeaturesWithSquareImages],
["PromoSectionFullWidthWithBackgroundImage", LazyPromoSectionFullWidthWithBackgroundImage],
["PromoSectionFullWidthWithOverlappingImageTiles", LazyPromoSectionFullWidthWithOverlappingImageTiles],
["PromoSectionLargeWithBackgroundImage", LazyPromoSectionLargeWithBackgroundImage],
["PromoSectionWithBackgroundImage", LazyPromoSectionWithBackgroundImage],
["PromoSectionWithFadingBackgroundImage", LazyPromoSectionWithFadingBackgroundImage],
["PromoSectionWithOverlappingImageTiles", LazyPromoSectionWithOverlappingImageTiles],
["RecentlyViewed", LazyRecentlyViewed],
["SimpleStats", LazySimpleStats],
["TeamSectionWithVerticalImages", LazyTeamSectionWithVerticalImages],
["TestimonialSideBySide", LazyTestimonialSideBySide],
["TestimonialWithBackgroundImage", LazyTestimonialWithBackgroundImage],
["TestimonialWithLargeAvatar", LazyTestimonialWithLargeAvatar],
["TestimonialWithOverlappingImage", LazyTestimonialWithOverlappingImage],
["VehicleShipping", LazyVehicleShipping],
["YoutubeVideo", LazyYoutubeVideo],
["Video1", LazyVideo1],
["FullWidthHero", LazyFullWidthHero],
["FullWidthPromotionSliderHero", LazyFullWidthPromotionSliderHero],
["Fullwidthhero1", LazyFullwidthhero1],
["Hero1", LazyHero1],
["Hero2", LazyHero2],
["SplitPaneHero", LazySplitPaneHero],
["TabColumns", LazyTabColumns],
["TabImageGrid", LazyTabImageGrid],
["TabLink", LazyTabLink],
["TabSimple", LazyTabSimple],
["Page", LazyPage],
["KbbAppraisal", LazyKbbAppraisal],
["SellHeader", LazySellHeader],
["StoryblokCatchAll", LazyStoryblokCatchAll],
["CapitalOneCalculator", LazyCapitalOneCalculator],
["CapitalOneLeadsNavigator", LazyCapitalOneLeadsNavigator],
["CapitalOnePrequalification", LazyCapitalOnePrequalification],
["CapitalOneShowroom", LazyCapitalOneShowroom],
["EdmundsTradeIn", LazyEdmundsTradeIn],
["EdmundsTradeInWidget", LazyEdmundsTradeInWidget],
["EdmundsTradeInWidgetSlim", LazyEdmundsTradeInWidgetSlim],
["IpacketButton", LazyIpacketButton],
["SvgoAtvs", LazySvgoAtvs],
["SvgoAutomotiveJaguar", LazySvgoAutomotiveJaguar],
["SvgoAutomotiveJeep", LazySvgoAutomotiveJeep],
["SvgoAutomotiveMini", LazySvgoAutomotiveMini],
["SvgoAutomotiveMitsubishi", LazySvgoAutomotiveMitsubishi],
["SvgoAutomotiveMustang", LazySvgoAutomotiveMustang],
["SvgoAutomotiveNissan", LazySvgoAutomotiveNissan],
["SvgoAutomotiveOpel", LazySvgoAutomotiveOpel],
["SvgoAutomotivePagani", LazySvgoAutomotivePagani],
["SvgoAutomotivePanoz", LazySvgoAutomotivePanoz],
["SvgoAutomotivePeterbilt", LazySvgoAutomotivePeterbilt],
["SvgoAutomotivePeugeot", LazySvgoAutomotivePeugeot],
["SvgoAutomotivePlymouth", LazySvgoAutomotivePlymouth],
["SvgoAutomotivePolestar", LazySvgoAutomotivePolestar],
["SvgoAutomotivePontiac", LazySvgoAutomotivePontiac],
["SvgoAutomotivePorsche", LazySvgoAutomotivePorsche],
["SvgoAutomotiveProton", LazySvgoAutomotiveProton],
["SvgoAutomotiveAbarth", LazySvgoAutomotiveAbarth],
["SvgoAutomotiveAcura", LazySvgoAutomotiveAcura],
["SvgoAutomotiveAixam", LazySvgoAutomotiveAixam],
["SvgoAutomotiveAlfaRomeo", LazySvgoAutomotiveAlfaRomeo],
["SvgoAutomotiveAlpinaBovensiepen", LazySvgoAutomotiveAlpinaBovensiepen],
["SvgoAutomotiveAmg", LazySvgoAutomotiveAmg],
["SvgoAutomotiveAstonMartin", LazySvgoAutomotiveAstonMartin],
["SvgoAutomotiveAudi", LazySvgoAutomotiveAudi],
["SvgoAutomotiveBentley", LazySvgoAutomotiveBentley],
["SvgoAutomotiveBmw", LazySvgoAutomotiveBmw],
["SvgoAutomotiveBrabus", LazySvgoAutomotiveBrabus],
["SvgoAutomotiveBrilliance", LazySvgoAutomotiveBrilliance],
["SvgoAutomotiveBugatti", LazySvgoAutomotiveBugatti],
["SvgoAutomotiveBuick", LazySvgoAutomotiveBuick],
["SvgoAutomotiveBydAuto", LazySvgoAutomotiveBydAuto],
["SvgoAutomotiveCadillac", LazySvgoAutomotiveCadillac],
["SvgoAutomotiveCat", LazySvgoAutomotiveCat],
["SvgoAutomotiveChana", LazySvgoAutomotiveChana],
["SvgoAutomotiveChery", LazySvgoAutomotiveChery],
["SvgoAutomotiveChevrolet", LazySvgoAutomotiveChevrolet],
["SvgoAutomotiveChrysler", LazySvgoAutomotiveChrysler],
["SvgoAutomotiveCitroen", LazySvgoAutomotiveCitroen],
["SvgoAutomotiveCorvette", LazySvgoAutomotiveCorvette],
["SvgoAutomotiveCupra", LazySvgoAutomotiveCupra],
["SvgoAutomotiveDacia", LazySvgoAutomotiveDacia],
["SvgoAutomotiveDaewoo", LazySvgoAutomotiveDaewoo],
["SvgoAutomotiveDaf", LazySvgoAutomotiveDaf],
["SvgoAutomotiveDaihatsu", LazySvgoAutomotiveDaihatsu],
["SvgoAutomotiveDaimler", LazySvgoAutomotiveDaimler],
["SvgoAutomotiveDmc", LazySvgoAutomotiveDmc],
["SvgoAutomotiveDodge", LazySvgoAutomotiveDodge],
["SvgoAutomotiveDs", LazySvgoAutomotiveDs],
["SvgoAutomotiveFerrari", LazySvgoAutomotiveFerrari],
["SvgoAutomotiveFiat", LazySvgoAutomotiveFiat],
["SvgoAutomotiveFisker", LazySvgoAutomotiveFisker],
["SvgoAutomotiveFord", LazySvgoAutomotiveFord],
["SvgoAutomotiveFreightlinerTrucks", LazySvgoAutomotiveFreightlinerTrucks],
["SvgoAutomotiveGaz", LazySvgoAutomotiveGaz],
["SvgoAutomotiveGeely", LazySvgoAutomotiveGeely],
["SvgoAutomotiveGinetta", LazySvgoAutomotiveGinetta],
["SvgoAutomotiveGmc", LazySvgoAutomotiveGmc],
["SvgoAutomotiveHolden", LazySvgoAutomotiveHolden],
["SvgoAutomotiveHonda", LazySvgoAutomotiveHonda],
["SvgoAutomotiveHummer", LazySvgoAutomotiveHummer],
["SvgoAutomotiveHyundai", LazySvgoAutomotiveHyundai],
["SvgoAutomotiveInfiniti", LazySvgoAutomotiveInfiniti],
["SvgoAutomotiveInternational", LazySvgoAutomotiveInternational],
["SvgoAutomotiveIsuzu", LazySvgoAutomotiveIsuzu],
["SvgoAutomotiveIveco", LazySvgoAutomotiveIveco],
["SvgoAutomotiveKenworth", LazySvgoAutomotiveKenworth],
["SvgoAutomotiveKia", LazySvgoAutomotiveKia],
["SvgoAutomotiveKoenigsegg", LazySvgoAutomotiveKoenigsegg],
["SvgoAutomotiveKomatsu", LazySvgoAutomotiveKomatsu],
["SvgoAutomotiveLada", LazySvgoAutomotiveLada],
["SvgoAutomotiveLamborghini", LazySvgoAutomotiveLamborghini],
["SvgoAutomotiveLancia", LazySvgoAutomotiveLancia],
["SvgoAutomotiveLandRover", LazySvgoAutomotiveLandRover],
["SvgoAutomotiveLexus", LazySvgoAutomotiveLexus],
["SvgoAutomotiveLincoln", LazySvgoAutomotiveLincoln],
["SvgoAutomotiveLotus", LazySvgoAutomotiveLotus],
["SvgoAutomotiveLucid", LazySvgoAutomotiveLucid],
["SvgoAutomotiveMackTrucks", LazySvgoAutomotiveMackTrucks],
["SvgoAutomotiveMagirus", LazySvgoAutomotiveMagirus],
["SvgoAutomotiveMan", LazySvgoAutomotiveMan],
["SvgoAutomotiveMaserati", LazySvgoAutomotiveMaserati],
["SvgoAutomotiveMaybach", LazySvgoAutomotiveMaybach],
["SvgoAutomotiveMazda", LazySvgoAutomotiveMazda],
["SvgoAutomotiveMclaren", LazySvgoAutomotiveMclaren],
["SvgoAutomotiveMercedes", LazySvgoAutomotiveMercedes],
["SvgoAutomotiveMercury", LazySvgoAutomotiveMercury],
["SvgoAutomotiveMg", LazySvgoAutomotiveMg],
["SvgoAutomotivePontiacTransAm", LazySvgoAutomotivePontiacTransAm],
["SvgoAutomotiveRamTrucks", LazySvgoAutomotiveRamTrucks],
["SvgoAutomotiveRangeRover", LazySvgoAutomotiveRangeRover],
["SvgoAutomotiveRenaultTrucks", LazySvgoAutomotiveRenaultTrucks],
["SvgoAutomotiveRenault", LazySvgoAutomotiveRenault],
["SvgoAutomotiveRimac", LazySvgoAutomotiveRimac],
["SvgoAutomotiveRollsRoyce", LazySvgoAutomotiveRollsRoyce],
["SvgoAutomotiveRover", LazySvgoAutomotiveRover],
["SvgoAutomotiveSaabScania", LazySvgoAutomotiveSaabScania],
["SvgoAutomotiveSaab", LazySvgoAutomotiveSaab],
["SvgoAutomotiveSeat", LazySvgoAutomotiveSeat],
["SvgoAutomotiveShelbyCobra", LazySvgoAutomotiveShelbyCobra],
["SvgoAutomotiveShelby", LazySvgoAutomotiveShelby],
["SvgoAutomotiveSkoda", LazySvgoAutomotiveSkoda],
["SvgoAutomotiveSmart", LazySvgoAutomotiveSmart],
["SvgoAutomotiveSsangyong", LazySvgoAutomotiveSsangyong],
["SvgoAutomotiveSubaru", LazySvgoAutomotiveSubaru],
["SvgoAutomotiveSuzuki", LazySvgoAutomotiveSuzuki],
["SvgoAutomotiveTata", LazySvgoAutomotiveTata],
["SvgoAutomotiveTesla", LazySvgoAutomotiveTesla],
["SvgoAutomotiveToyota", LazySvgoAutomotiveToyota],
["SvgoAutomotiveUaz", LazySvgoAutomotiveUaz],
["SvgoAutomotiveUdTrucks", LazySvgoAutomotiveUdTrucks],
["SvgoAutomotiveVolkswagen", LazySvgoAutomotiveVolkswagen],
["SvgoAutomotiveVolvo", LazySvgoAutomotiveVolvo],
["SvgoAutomotiveWesternStar", LazySvgoAutomotiveWesternStar],
["SvgoCars", LazySvgoCars],
["SvgoCertifiedPreOwned", LazySvgoCertifiedPreOwned],
["SvgoFacebook", LazySvgoFacebook],
["SvgoFeaturesAdaptiveCruiseControl", LazySvgoFeaturesAdaptiveCruiseControl],
["SvgoFeaturesAndroidAuto", LazySvgoFeaturesAndroidAuto],
["SvgoFeaturesAppleCarplay", LazySvgoFeaturesAppleCarplay],
["SvgoFeaturesAutomaticClimateControl", LazySvgoFeaturesAutomaticClimateControl],
["SvgoFeaturesAutomaticCruiseControl", LazySvgoFeaturesAutomaticCruiseControl],
["SvgoFeaturesBackupCamera", LazySvgoFeaturesBackupCamera],
["SvgoFeaturesBlindSpotMonitor", LazySvgoFeaturesBlindSpotMonitor],
["SvgoFeaturesBluetooth", LazySvgoFeaturesBluetooth],
["SvgoFeaturesCollisionWarning", LazySvgoFeaturesCollisionWarning],
["SvgoFeaturesFogLights", LazySvgoFeaturesFogLights],
["SvgoFeaturesHeatedSeats", LazySvgoFeaturesHeatedSeats],
["SvgoFeaturesKeylessEntry", LazySvgoFeaturesKeylessEntry],
["SvgoFeaturesLaneDepartureWarning", LazySvgoFeaturesLaneDepartureWarning],
["SvgoFeaturesLaneKeepAssist", LazySvgoFeaturesLaneKeepAssist],
["SvgoFeaturesLeatherSeats", LazySvgoFeaturesLeatherSeats],
["SvgoFeaturesNavigation", LazySvgoFeaturesNavigation],
["SvgoFeaturesPanoramicSunroof", LazySvgoFeaturesPanoramicSunroof],
["SvgoFeaturesParkingSenorsAssist", LazySvgoFeaturesParkingSenorsAssist],
["SvgoFeaturesPowerSeats", LazySvgoFeaturesPowerSeats],
["SvgoFeaturesPremiumAudio", LazySvgoFeaturesPremiumAudio],
["SvgoFeaturesPushStart", LazySvgoFeaturesPushStart],
["SvgoFeaturesRainSensingWipers", LazySvgoFeaturesRainSensingWipers],
["SvgoFeaturesRearAc", LazySvgoFeaturesRearAc],
["SvgoFeaturesRemoteStart", LazySvgoFeaturesRemoteStart],
["SvgoFeaturesSatelliteRadioReady", LazySvgoFeaturesSatelliteRadioReady],
["SvgoFeaturesSunroof", LazySvgoFeaturesSunroof],
["SvgoFeaturesTowPackage", LazySvgoFeaturesTowPackage],
["SvgoFeaturesWiFiHotspot", LazySvgoFeaturesWiFiHotspot],
["SvgoFeaturesWirelessPhoneCharging", LazySvgoFeaturesWirelessPhoneCharging],
["SvgoFeaturesXenonHeadlights", LazySvgoFeaturesXenonHeadlights],
["SvgoInstagram", LazySvgoInstagram],
["SvgoLeaf", LazySvgoLeaf],
["SvgoPlug", LazySvgoPlug],
["SvgoX", LazySvgoX],
["SvgoYoutube", LazySvgoYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
